import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { initialSearchState } from "src/reducks/SearchStore/initializes";

export const searchSlice = createSlice({
  initialState: initialSearchState,
  name: "search",
  reducers: {
    addSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    resetSearchToggle: (state) => {
      state.toggleSearch = false;
    },
    resetSearchWord: (state) => {
      state.search = "";
    },
    setToggleSearch: (state) => {
      state.toggleSearch = !state.toggleSearch;
    },
  },
});

export const {
  addSearch,
  resetSearchToggle,
  resetSearchWord,
  setToggleSearch,
} = searchSlice.actions;

export const searchReducer = searchSlice.reducer;
